import CommunityFeed from "@/components/community/CommunityFeed";
import CommunitySidebar from "@/components/community/CommunitySidebar";
import ResponsiveLayout from "@/components/layout/ResponsiveLayout";

export default function Community() {
  return (
    <div className="space-y-4 pb-20 lg:pb-6">
      <h1 className="text-2xl font-bold">Community</h1>
      <ResponsiveLayout
        main={
          <div className="lg:max-w-3xl lg:mx-auto">
            <CommunityFeed showComposer showFilters />
          </div>
        }
        sidebar={<CommunitySidebar />}
        sidebarWidth="w-72"
      />
    </div>
  );
}
